// extracted by mini-css-extract-plugin
export default {"info":"PatientInfo_info__lkm0A"};